import { getPath } from '@/router/common'

const baseUrl = {
  title: '轨迹回推平台日志',
  path: 'trajectoryLog'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'Trajectory_Log',
    component: () =>
      import(/* webpackChunkName: "Trajectory_Log" */ '@/views/trajectoryLog/index.vue'),
    meta: {
      title: '轨迹回推日志'
    }
  }
]
